module.exports = __webpack_public_path__ + "img/add-user-group-woman-man.999683e8.png";